var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "_x3C_Layer_x3E_",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message_x2C__letter_x2C__mail_x2C__unsubscribe_x2C__emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4039_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4040_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4449_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.5,
    x2: 26.5,
    y1: 15.8,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4423_",
    points: "     20.5,1.5 5.5,1.5 5.5,15.8    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4422_",
    points: "     20.5,1.5 26.479,7.5 20.5,7.5 20.5,4    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4299_",
    points: "     21,20.111 29.5,13.5 29.5,30.5 2.5,30.5 2.5,13.5 11.054,20.153    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4298_",
    points: "     2.5,29 16,19.5 29.5,29    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4297_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.495,
    x2: 29.5,
    y1: 11.052,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4296_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.5,
    x2: 5.5,
    y1: 13.5,
    y2: 11.056
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4041_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "      M15,14.521c0-0.55,0.45-1,1-1s1,0.45,1,1",
    fill: "none",
    id: "XMLID_4295_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M20.5,12c0.27,0,0.5,0.23,0.5,0.5S20.77,13,20.5,13S20,12.77,20,12.5S20.23,12,20.5,12z",
    fill: "none",
    id: "XMLID_4294_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M11.5,12c0.27,0,0.5,0.23,0.5,0.5S11.77,13,11.5,13S11,12.77,11,12.5S11.23,12,11.5,12z",
    fill: "none",
    id: "XMLID_4042_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4026_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4027_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4038_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.5,
    x2: 26.5,
    y1: 15.8,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4037_",
    points: "     20.5,1.5 5.5,1.5 5.5,15.8    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4036_",
    points: "     20.5,1.5 26.479,7.5 20.5,7.5 20.5,4    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4035_",
    points: "     21,20.111 29.5,13.5 29.5,30.5 2.5,30.5 2.5,13.5 11.054,20.153    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4034_",
    points: "     2.5,29 16,19.5 29.5,29    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4033_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.495,
    x2: 29.5,
    y1: 11.052,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4032_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.5,
    x2: 5.5,
    y1: 13.5,
    y2: 11.056
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4028_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "      M15,14.521c0-0.55,0.45-1,1-1s1,0.45,1,1",
    fill: "none",
    id: "XMLID_4031_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M20.5,12c0.27,0,0.5,0.23,0.5,0.5S20.77,13,20.5,13S20,12.77,20,12.5S20.23,12,20.5,12z",
    fill: "none",
    id: "XMLID_4030_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M11.5,12c0.27,0,0.5,0.23,0.5,0.5S11.77,13,11.5,13S11,12.77,11,12.5S11.23,12,11.5,12z",
    fill: "none",
    id: "XMLID_4029_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/unsubscribe.7ff3dda729fdf9a14c478ddbfec578ae.svg";
export { ForwardRef as ReactComponent };